<template>
	<div>
		<section
			class="space bg-color--dark--1 h-min-100vh d-flex align-items-center mt-4"
		>
			<div class="svg-shape--top w-100 opacity--05">
				<img src="/assets/img/wave-8.svg" alt="wave" class="svg fill--white" />
			</div>
			<!-- end of whole area svg bg -->
			<div class="svg-shape--top opacity--10">
				<img src="assets/img/wave-9.svg" alt="wave" class="svg fill--white" />
			</div>

			<div class="container">
				<div class="row">
					<div class="col-12 mx-auto   mb-4 mb-lg-5">
						<div class="form--v2 px-3 py-3 rounded--11 bg-color--light--1">
							<h5 class="text-center mb-3">
								{{ getCustomerFirstName }} {{ getCustomerLastName }}
							</h5>
							<router-tab :tabs="tabs" />
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
	export default {
		props: ["id"],
		name: "Default-tabs",
		data() {
			return {
				tabs: [
					// Just set up fullpath, RouterTab will automatically get meta from your router configuration
					"/supplier/customers/" + this.$route.params.id,
					// Specify if it should be closable or not
					{
						to: "/supplier/customers/" + this.$route.params.id + "/edit",
						closable: false,
						children:[
							{
							to:"",
							closable:false
							}
						]

					},
					{
						to: "/supplier/customers/" + this.$route.params.id + "/set-level",
						closable: false
					},
					{
						to: "/supplier/customers/" + this.$route.params.id + "/first-surety",
						closable: false
					},
					{
						to: "/supplier/customers/" + this.$route.params.id + "/second-surety",
						closable: false
					},
					{
						to: "/supplier/customers/" + this.$route.params.id + "/contract",
						closable: false
					},
					// {
					// 	to: "/supplier/customers/" + this.$route.params.id + "/instalments",
					// 	closable: true
					// },
					// {
					// 	to: "/supplier/customers/" + this.$route.params.id + "/payments",
					// 	closable: true
					// }
				]
			};
		},
		computed: {
			getCustomerFirstName() {
				return this.$store.getters.getSuppliersCustomerFirstName;
			},
			getCustomerLastName() {
				return this.$store.getters.getSuppliersCustomerLastName;
			}
		},
		mounted() {
			console.log("router param= ", this.$route.params.id);
		}
	};
</script>

<style >
	.custom-tab {
    /* background-color: #e6fdff; */
		background-color: white;
	}
</style>